import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import styles from './index.css';

import RestaurantItem from '../restaurantItem';

class RestaurantList extends PureComponent {
    static propTypes = {
        list: PropTypes.array,
    };

    emptyFun = () => {};

    render() {
        const { list } = this.props;

        return (
            <div className={styles.restaurantList}>
                {list.map((item, index) => <RestaurantItem key={item.index} data={item} callbackIndex={index} />)}
            </div>
        );
    }
}

export default errorBoundary(RestaurantList);
